import "./SubscriptionPricing.scss";

const SubscriptionPricing = (props) => {
  return (
    <section className="subscription-pricing bgcol">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-12">
            <div className="subscriptions-row">
              {/* <h4 className="subscription-title">Unlock Your Full Potential</h4> */}
              <h2 className="subscription-next-title text-center">
                Unlock Your Full Potential
              </h2>
              <span className="subscriptions-subhead text-center d-block">
                Take your real estate career to the next level with exclusive
                learning, premium tools, and expert coaching. Choose the plan
                that fits your ambition.
              </span>
            </div>
          </div>
        </div>
        <div className="row coursecard-row">
          <div className="col-md-4">
            <div className="coursecard-bar">
              {/* <div className="text-center icon-box">
                <svg
                  width="46"
                  height="46"
                  viewBox="0 0 46 46"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="3"
                    y="3"
                    width="40"
                    height="40"
                    rx="20"
                    fill="#F4EBFF"
                  />
                  <rect
                    x="3"
                    y="3"
                    width="40"
                    height="40"
                    rx="20"
                    stroke="#F9F5FF"
                    strokeWidth="6"
                  />
                  <path
                    d="M23.8334 14.6666L16.4112 23.5732C16.1206 23.922 15.9752 24.0964 15.973 24.2437C15.9711 24.3717 16.0281 24.4935 16.1277 24.574C16.2423 24.6666 16.4693 24.6666 16.9234 24.6666H23L22.1667 31.3333L29.5888 22.4267C29.8795 22.0779 30.0248 21.9035 30.027 21.7562C30.029 21.6282 29.9719 21.5064 29.8723 21.4259C29.7577 21.3333 29.5307 21.3333 29.0767 21.3333H23L23.8334 14.6666Z"
                    stroke="#7F56D9"
                    strokeWidth="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div> */}
              <div className="img-box-plan">
                  <img src="/images/starter.png" className="img-fluid" />
              </div>
              {/* <span className="card-h1row">Basic</span> */}
              {/* <label for="" className="card-h2row">
                Starter Plan
              </label> */}
              {/* <span className="card-h3row">Zero cost forever.</span> */}
              <ul>
                <li>
                Get access to essential courses and resources to begin your journey in real estate.
                </li>
              </ul>
              <div className="footer-sub-btn">
                <button
                  type="button"
                  className="accessbtn"
                  onClick={() => {
                    if (document.getElementById("subscriptions-row")) {
                      document
                        .getElementById("subscriptions-row")
                        .scrollIntoView();
                    }
                  }}
                >
                  Start Now
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="coursecard-bar">
              {/* <div className="text-center icon-box">
              <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="3" width="40" height="40" rx="20" fill="#F4EBFF"/>
              <rect x="3" y="3" width="40" height="40" rx="20" stroke="#F9F5FF" stroke-width="6"/>
              <path d="M14.6667 25.0832L22.7019 29.1008C22.8113 29.1555 22.8659 29.1828 22.9232 29.1936C22.974 29.2031 23.0261 29.2031 23.0769 29.1936C23.1342 29.1828 23.1889 29.1555 23.2982 29.1008L31.3334 25.0832M14.6667 20.9166L22.7019 16.899C22.8113 16.8443 22.8659 16.817 22.9232 16.8062C22.974 16.7967 23.0261 16.7967 23.0769 16.8062C23.1342 16.817 23.1889 16.8443 23.2982 16.899L31.3334 20.9166L23.2982 24.9342C23.1889 24.9888 23.1342 25.0161 23.0769 25.0269C23.0261 25.0364 22.974 25.0364 22.9232 25.0269C22.8659 25.0161 22.8113 24.9888 22.7019 24.9342L14.6667 20.9166Z" stroke="#7F56D9" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              </div> */}
               <div className="img-box-plan">
                  <img src="/images/pro.png" className="img-fluid" />
              </div>
              {/* <span className="card-h1row">Pro Plan</span> */}
              {/* <label for="" className="card-h2row">
                Pro Plan
              </label> */}
              {/* <span className="card-h3row">Zero cost forever.</span> */}
              <ul>
                <li>
                Unlock foundational courses, select video library resources, and 2 monthly expert webinars. Enjoy exclusive offers, earn reward points, and access interactive roleplays with added discounts on courses and certifications.
                </li>
              </ul>
              <div className="footer-sub-btn">
                <button
                  type="button"
                  className="accessbtn"
                  onClick={() => {
                    if (document.getElementById("subscriptions-row")) {
                      document
                        .getElementById("subscriptions-row")
                        .scrollIntoView();
                    }
                  }}
                >
                  Upgrade to Pro
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="coursecard-bar">
              {/* <div className="text-center icon-box">
              <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="3" width="40" height="40" rx="20" fill="#F4EBFF"/>
                <rect x="3" y="3" width="40" height="40" rx="20" stroke="#F9F5FF" stroke-width="6"/>
                <g clip-path="url(#clip0_2337_7183)">
                <path d="M14.6667 23L22.7019 27.0176C22.8113 27.0722 22.8659 27.0996 22.9232 27.1103C22.974 27.1198 23.0261 27.1198 23.0769 27.1103C23.1342 27.0996 23.1889 27.0722 23.2982 27.0176L31.3334 23M14.6667 27.1666L22.7019 31.1842C22.8113 31.2389 22.8659 31.2662 22.9232 31.277C22.974 31.2865 23.0261 31.2865 23.0769 31.277C23.1342 31.2662 23.1889 31.2389 23.2982 31.1842L31.3334 27.1666M14.6667 18.8333L22.7019 14.8157C22.8113 14.7611 22.8659 14.7337 22.9232 14.723C22.974 14.7134 23.0261 14.7134 23.0769 14.723C23.1342 14.7337 23.1889 14.7611 23.2982 14.8157L31.3334 18.8333L23.2982 22.8509C23.1889 22.9056 23.1342 22.9329 23.0769 22.9436C23.0261 22.9532 22.974 22.9532 22.9232 22.9436C22.8659 22.9329 22.8113 22.9056 22.7019 22.8509L14.6667 18.8333Z" stroke="#7F56D9" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                <clipPath id="clip0_2337_7183">
                <rect width="20" height="20" fill="white" transform="translate(13 13)"/>
                </clipPath>
                </defs>
                </svg>
              </div> */}
               <div className="img-box-plan">
                  <img src="/images/premium.png" className="img-fluid" />
              </div>
              {/* <span className="card-h1row">Basic</span> */}
              {/* <label for="" className="card-h2row">
                Premium Plan
              </label> */}
              {/* <span className="card-h3row">Zero cost forever.</span> */}
              <ul>
                <li>
                Get unlimited access to all courses, webinars, and video libraries. Maximize your learning with top-tier discounts, personalized coaching, and priority support for an elite real estate experience.
                </li>
              </ul>
              <div className="footer-sub-btn">
                <button
                  type="button"
                  className="accessbtn"
                  onClick={() => {
                    if (document.getElementById("subscriptions-row")) {
                      document
                        .getElementById("subscriptions-row")
                        .scrollIntoView();
                    }
                  }}
                >
                  Go Premium
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default SubscriptionPricing;
